<template lang="pug">
.question.d-flex.flex-column
  img(:src="question.FAQCoverImage")
  .title_btn.d-flex.justify-content-between.align-items-center(
    @click="toDetail"
  )
    h5.i_body.i_mt_3.flex-shrink-1 {{ question.FAQTitle }}
    svg-icon.flex-shrink-0(
      iconClass="arrow_bottom_g",
      className="arrow_bottom_g"
    )
  .divider
  p.i_mt_4 {{ question.FAQBrief }}
</template>

<script>
export default {
  name: "Question",
  props: {
    question: Object,
    selected: Boolean,
  },
  methods: {
    toDetail() {
      this.$router.push({
        name: "CustomerServiceFAQDetail",
        query: { id: this.question.FAQID },
      });
      if ("CustomerServiceFAQDetail" == this.$route.name) {
        this.$emit("changeQuestion", this.question.FAQID);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/common/question";
</style>
